import { Pill } from '~/components';
import type { PillTypes } from '~/components/Pill/Pill';
import { ContractStatus } from '../types';

const STATUS_CONFIG: Record<ContractStatus, { label: string; type: PillTypes }> = {
  ACTIVE: { label: 'Active', type: 'success' },
  PENDING: { label: 'Upcoming', type: 'warning' },
  COMPLETED: { label: 'Completed', type: 'success' },
  TERMINATED: { label: 'Terminated', type: 'danger' },
};

interface Props {
  status: ContractStatus;
  cyTag?: string;
}

export const ContractStatusBadge = ({ status, cyTag }: Props) => {
  const config = STATUS_CONFIG[status];
  return <Pill label={config.label} type={config.type} cyTag={cyTag} />;
};
